import { Injectable } from '@angular/core';
import { SnackbarService } from './snackbar.service';
import { LoggerService } from 'src/app/core/logger.service';
import { LinkListService } from 'src/app/links/services/link-list.service';
import { DialogService } from './dialog.service';
import { FileItem, LinkItem } from '../models';
import { LinkInfoDialogComponent } from '../components/dialog-link/link-info-dialog/link-info-dialog.component';
import { Clipboard } from '@angular/cdk/clipboard';

@Injectable({
  providedIn: 'root',
})
export class LinkCopyService {
  constructor(
    private clipboard: Clipboard,
    private snackbarService: SnackbarService,
    private logger: LoggerService,
    private linkList: LinkListService,
    private dialogService: DialogService,
  ) {}

  public async copyLink(rowData: FileItem): Promise<void> {
    try {
      const data = await this.linkList.getLink(rowData.sync_id, rowData.name);
      const link = data as LinkItem;

      if (link.cnt > 0) {
        this.dialogService.open(LinkInfoDialogComponent, {
          data: { link },
        });
        return;
      }
      this.clipboard.copy(link.linkUrl);
      this.snackbarService.showMessage('success', 'Link copied.');
    } catch (error) {
      this.snackbarService.showMessage('critical', "Couldn't complete action. Try again.");
      this.logger.error(error);
    }
  }
}
